<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="control" title="Solution" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                Smart Farm Solution
            </template>
            <tit-wrap-large class="mb-0">
                <b>The Integrated Vertical Farm Control System</b> <br class="d-none d-lg-block" />monitors a variety of cultivation factors of the vertical farm and controls the growth environment of crops
                <template #text>The system monitors the state of each zone of the vertical farm and the root zones of the crops through its sensors and controls nutrients, irrigation, and environmental factors required for crop growth. It enables efficient vertical farm operation.</template>
            </tit-wrap-large>
        </page-section>

        <page-section class="d-flex align-center min-h-lg-980px">
            <div class="page-section__bg" style="background-image:url(/images/sub/solution/plant/control-bg.jpg);"></div>
            <v-img max-width="350" :aspect-ratio="700 / 2772" src="/images/sub/solution/plant/control-img-mo-en.png" class="d-md-none mx-auto" data-aos="fade" data-aos-delay="100" />
            <v-img max-width="1200" :aspect-ratio="1200 / 244" src="/images/sub/solution/plant/control-img-en.png" class="d-none d-md-block mx-auto" data-aos="fade" data-aos-delay="100" />
        </page-section>

        <page-section class="grey lighten-5">
            <v-card outlined rounded="" data-aos="fade" data-aos-delay="100">
                <div class="d-flex pa-30px pa-md-40px pa-lg-80px">
                    <v-img max-width="1000" :aspect-ratio="1000 / 634" src="/images/sub/solution/plant/control-img2.png" class="mx-auto" />
                </div>
            </v-card>

            <div class="pt-30px pt-md-40px pt-lg-80px">
                <v-row class="ma-n20px ma-md-n30px">
                    <v-col cols="12" md="6" class="pa-20px pa-md-30px" data-aos="fade-left" data-aos-delay="100">
                        <tit-wrap-sprout>
                            Monitoring on the vertical farm and root zones
                        </tit-wrap-sprout>

                        <txt-item titleClass="w-md-140px">
                            <template #title>Measurement items</template>
                            Temperature, humidity, pH, EC, CO2, and artificial LED light
                        </txt-item>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-20px pa-md-30px" data-aos="fade-left" data-aos-delay="200">
                        <tit-wrap-sprout>
                            Integrated Vertical Farm Control System
                        </tit-wrap-sprout>

                        <txt-item titleClass="w-md-140px">
                            <template #title>Control items</template>
                            Air-conditioning, ventilation, artificial LED lights, chiller, irrigation, and water level of cultivation shelves
                        </txt-item>
                    </v-col>
                </v-row>
            </div>
        </page-section>

        <page-section class="page-section--last">
            <v-card outlined rounded="" data-aos="fade" data-aos-delay="100">
                <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                    <div class="pa-30px pa-md-40px px-lg-80px">
                        <v-img max-width="770" :width="$vuetify.breakpoint.lgAndUp ? '770' : ''" :aspect-ratio="770 / 376" src="/images/sub/solution/plant/control-img3.png" class="mx-auto" />
                        <div class="pt-30px pt-md-40px pt-lg-60px">
                            <tit-wrap-small>
                                Integrated IoT Environmental Control System
                                <template #text>You can monitor information on the growth of crops and control the environmental factors via your PC and mobile device.</template>
                            </tit-wrap-small>
                        </div>
                    </div>
                </v-responsive>
            </v-card>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
